var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrice24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50011 2.49967H4.50006C3.3955 2.49967 2.50008 3.39508 2.50006 4.49964L2.5 7.5M5.50011 2.49967V1.5M5.50011 2.49967H18.5001M5.50011 2.49967V4.5M18.5001 2.49967H19.5001C20.6047 2.49967 21.5001 3.39512 21.5001 4.49971L21.5 7.5M18.5001 2.49967V1.5M18.5001 2.49967V4.5M2.5 7.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V7.5M2.5 7.5H21.5",
    stroke: "#0E1C36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5V13C13.5 12.1716 12.8284 11.5 12 11.5V11.5M10.5 15.5V16C10.5 16.8284 11.1716 17.5 12 17.5V17.5M12 17.5V17.5C12.8284 17.5 13.5 16.8284 13.5 16V15.9222C13.5 15.6584 13.3682 15.4121 13.1487 15.2658L10.8513 13.7342C10.6318 13.5879 10.5 13.3416 10.5 13.0778V13C10.5 12.1716 11.1716 11.5 12 11.5V11.5M12 17.5V18.5M12 11.5V10.5",
    stroke: "#0E1C36",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrice24);
export default __webpack_public_path__ + "static/media/icon-price-24.d2f323b81948e7763c48de1df231e781.svg";
export { ForwardRef as ReactComponent };